// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.home .homeContainer {
  /* position: absolute; */
  /* top: 30%; */
  text-align: center;
  display: flex;
  margin-top: 70px;
}

.windowingButtonPloicy{
padding: 0 !important;
margin: 0 !important;
  font-size: 90% !important; /* Inherit font size */
  text-transform: capitalize !important;
border: none !important;
  cursor: pointer !important; /* Show pointer cursor on hover */

  text-decoration: none !important;
}

.homeContainerGrid {
  display: flex;
  justify-content: space-evenly;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}
.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop {
  backdrop-filter: blur(2px) !important;
}

.home .homeContainer .MuiGrid-root .MuiPaper-root {
  width: 100% !important;
  text-align: left;
}
.sideShortcuts .MuiPaper-root {
  width: 220px !important;
  text-align: left;
  /* height: auto; */
}

.total div {
  text-align: center;
  font-size: 30px;
  color: white;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #282b30;
  height: auto;
}

.total .imageHolder .mui-image-wrapper img {
  width: 200px !important;
  height: 100px !important;
  object-fit: contain !important;
}

.home .iconButton {
  width: 22px;
  color: white !important;
}

.home .searchIcon {
  margin-left: 8px;
}

.home .card {
  background-color: #282b30;
  width: 290px;
  height: 200px;
}

.home .started {
  text-align: left;
  color: white;
  margin-bottom: 2rem;
  display: flex;
}

.home .wrapper {
  display: flex;
}

.home .titleContainerHome {
  width: 100%;
  display: flex;
  align-items: center;
}

.home .getStarted {
  display: inline-block;
  flex: 1 1;
  font-size: 45px;
  color: #bbbcbd;
}

.home .logoutButton {
  display: flex;
  flex: 1 1;
  cursor: pointer;
  justify-content: flex-end;
  z-index: 9;
}

.home .logoutButton button {
  display: flex;
  background-color: #07070e;
  cursor: pointer;
  color: #bbbcbd !important;
  font-size: 20px;
  border: none;
  align-items: center;
  gap: 10px;
}

.home .logoutButton button:hover {
  background-color: #07070e;
  cursor: pointer;
  color: #fbfcfd !important;
}

.home .logoutButton button .css-i4bv87-MuiSvgIcon-root {
  width: 20px !important;
  height: 20px !important;
}

.home .logoutButton button .css-i4bv87-MuiSvgIcon-root:hover {
  background-color: #fbfcfd !important;
}

.home .mainButton Button {
  background: linear-gradient(
    90deg,
    #4996ee 0%,
    rgba(37, 75, 119) 100%
  );
  color: #fff;
  font-size: 85% !important;
  border-radius: 0;
  width: 100%;
  padding: 3px 8px;
  text-wrap: nowrap;
}

.home .mainButton Button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
  color: #fff;
}

.home .imageHolder {
  padding: 0 1rem;
  text-align: center;
  margin-top: -10%;
}

.paperContainer .mainButton {
  padding: 1rem;
}

.shortcuts {
  /* .home .shortcuts { */
  text-align: left !important;
  color: white;
  padding-right: 75px;
}

/* .home .shortcuts ul { */
.shortcuts ul {
  list-style-type: none !important;
  text-align: left !important;
  color: white;
  padding-inline-start: 20px;
}

.shortcuts ul li {
  /* .home .shortcuts ul li { */
  color: #4996ee;
  cursor: pointer;
}

.shortcuts ul h2 {
  /* .home .shortcuts ul h2 { */
  color: #bbbcbd;
}

/* .home .searchInput input { */
.searchInput input {
  background-color: #282b30;
  /* border: 1px solid #777a84; */
  height: 15px;
  width: 190px;
  /* padding-left: 8px; */
  color: white;
  font-size: 16px;
}

/* .home .searchInput input::placeholder { */
.searchInput input::placeholder {
  padding-left: 5px;
  color: #777a84;
  opacity: 1;
  /* Firefox */
}

/* .home .searchInput { */
.searchInput {
  text-align: center;
  margin-top: 10px;
  padding: 5px 15px;
}

.sideShortcuts.visible {
  right: 0;
}

.toggleButtonContainer {
  position: absolute;
  right: -42px !important;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  z-index: 2;
}
.toggleButtonContainer button {
  border-radius: 0 !important;
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #fff;
}

.toggleButtonContainer button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

.toggleButton {
  border-radius: 0;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #282b30;
  color: white !important;

  right: 0 !important;
}

.shortcutsContainer {
  /* position: absolute;
  bottom: 0;
  top: 0;
  right: 0; */
  display: flex;
  /* align-items: center; */
}

@media (max-width: 900px) {
  .paperContainer {
    padding: 20px 0;
  }
}

@media (min-width: 1200px) {
  .sideShortcuts {
    display: block !important;
  }

  .css-ymyjcp-MuiGrid-root {
    gap: 40px;
  }

  .homeContainer {
    width: calc(100% - 225px);
  }

  .homeContainerGrid {
    display: flex;
    /* gap: 90px; */
    justify-content: center;
    padding: 0 30px;
  }

  .paperContainer {
    text-align: center;
    align-items: center;
    /* width: 300px; */
  }

  .toggleButtonContainer {
    display: none;
  }
}

@media (max-width: 1200px) {
  .sideShortcuts {
    position: absolute;
    right: -250px;
    /* top: 30%;
    bottom: 0; */
    transition: right 0.3s ease;
    z-index: 1;
  }

  .css-ymyjcp-MuiGrid-root {
    flex-direction: column;
  }

  .homeContainer {
    width: calc(100% - 50px);
  }
}

@media (min-width: 1900px) {
  .home .shortcuts ul li {
    font-size: 24px;
  }

  .sideShortcuts {
    top: 10%;
  }
}

@media (min-width: 2200px) {
  .home .started {
    font-size: 40px !important;
    margin-top: 4%;
  }

  .homeContainer {
    width: calc(100% - 400px);
  }

  .sideShortcuts .MuiPaper-root {
    width: 400px !important;
    min-height: 100%;
  }

  .searchInput input {
    width: 100% !important;
    font-size: 25px !important;
  }

  .shortcuts ul li {
    font-size: 27px !important;
  }

  .searchInput .css-i4bv87-MuiSvgIcon-root {
    font-size: 50px !important;
  }

  .homeContainerGrid {
    display: flex;
    justify-content: center;
    padding: 0 50px;
  }

  .paperContainer .mainButton Button {
    height: 100px;
    font-size: 250% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;AACA,qBAAqB;AACrB,oBAAoB;EAClB,yBAAyB,EAAE,sBAAsB;EACjD,qCAAqC;AACvC,uBAAuB;EACrB,0BAA0B,EAAE,iCAAiC;;EAE7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;;GAIC;EACD,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;EACD,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,WAAW;AACb;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;AACrB;;AAEA;EACE;;;aAGW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb;gBACY;IACZ,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF","sourcesContent":[".home {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.home .homeContainer {\n  /* position: absolute; */\n  /* top: 30%; */\n  text-align: center;\n  display: flex;\n  margin-top: 70px;\n}\n\n.windowingButtonPloicy{\npadding: 0 !important;\nmargin: 0 !important;\n  font-size: 90% !important; /* Inherit font size */\n  text-transform: capitalize !important;\nborder: none !important;\n  cursor: pointer !important; /* Show pointer cursor on hover */\n\n  text-decoration: none !important;\n}\n\n.homeContainerGrid {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop {\n  backdrop-filter: blur(2px) !important;\n}\n\n.home .homeContainer .MuiGrid-root .MuiPaper-root {\n  width: 100% !important;\n  text-align: left;\n}\n.sideShortcuts .MuiPaper-root {\n  width: 220px !important;\n  text-align: left;\n  /* height: auto; */\n}\n\n.total div {\n  text-align: center;\n  font-size: 30px;\n  color: white;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #282b30;\n  height: auto;\n}\n\n.total .imageHolder .mui-image-wrapper img {\n  width: 200px !important;\n  height: 100px !important;\n  object-fit: contain !important;\n}\n\n.home .iconButton {\n  width: 22px;\n  color: white !important;\n}\n\n.home .searchIcon {\n  margin-left: 8px;\n}\n\n.home .card {\n  background-color: #282b30;\n  width: 290px;\n  height: 200px;\n}\n\n.home .started {\n  text-align: left;\n  color: white;\n  margin-bottom: 2rem;\n  display: flex;\n}\n\n.home .wrapper {\n  display: flex;\n}\n\n.home .titleContainerHome {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.home .getStarted {\n  display: inline-block;\n  flex: 1;\n  font-size: 45px;\n  color: #bbbcbd;\n}\n\n.home .logoutButton {\n  display: flex;\n  flex: 1;\n  cursor: pointer;\n  justify-content: flex-end;\n  z-index: 9;\n}\n\n.home .logoutButton button {\n  display: flex;\n  background-color: #07070e;\n  cursor: pointer;\n  color: #bbbcbd !important;\n  font-size: 20px;\n  border: none;\n  align-items: center;\n  gap: 10px;\n}\n\n.home .logoutButton button:hover {\n  background-color: #07070e;\n  cursor: pointer;\n  color: #fbfcfd !important;\n}\n\n.home .logoutButton button .css-i4bv87-MuiSvgIcon-root {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.home .logoutButton button .css-i4bv87-MuiSvgIcon-root:hover {\n  background-color: #fbfcfd !important;\n}\n\n.home .mainButton Button {\n  background: linear-gradient(\n    90deg,\n    #4996ee 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #fff;\n  font-size: 85% !important;\n  border-radius: 0;\n  width: 100%;\n  padding: 3px 8px;\n  text-wrap: nowrap;\n}\n\n.home .mainButton Button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n  color: #fff;\n}\n\n.home .imageHolder {\n  padding: 0 1rem;\n  text-align: center;\n  margin-top: -10%;\n}\n\n.paperContainer .mainButton {\n  padding: 1rem;\n}\n\n.shortcuts {\n  /* .home .shortcuts { */\n  text-align: left !important;\n  color: white;\n  padding-right: 75px;\n}\n\n/* .home .shortcuts ul { */\n.shortcuts ul {\n  list-style-type: none !important;\n  text-align: left !important;\n  color: white;\n  padding-inline-start: 20px;\n}\n\n.shortcuts ul li {\n  /* .home .shortcuts ul li { */\n  color: #4996ee;\n  cursor: pointer;\n}\n\n.shortcuts ul h2 {\n  /* .home .shortcuts ul h2 { */\n  color: #bbbcbd;\n}\n\n/* .home .searchInput input { */\n.searchInput input {\n  background-color: #282b30;\n  /* border: 1px solid #777a84; */\n  height: 15px;\n  width: 190px;\n  /* padding-left: 8px; */\n  color: white;\n  font-size: 16px;\n}\n\n/* .home .searchInput input::placeholder { */\n.searchInput input::placeholder {\n  padding-left: 5px;\n  color: #777a84;\n  opacity: 1;\n  /* Firefox */\n}\n\n/* .home .searchInput { */\n.searchInput {\n  text-align: center;\n  margin-top: 10px;\n  padding: 5px 15px;\n}\n\n.sideShortcuts.visible {\n  right: 0;\n}\n\n.toggleButtonContainer {\n  position: absolute;\n  right: -42px !important;\n  top: 50%;\n  transform: translateY(-50%) rotate(-90deg);\n  z-index: 2;\n}\n.toggleButtonContainer button {\n  border-radius: 0 !important;\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #fff;\n}\n\n.toggleButtonContainer button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n.toggleButton {\n  border-radius: 0;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #282b30;\n  color: white !important;\n\n  right: 0 !important;\n}\n\n.shortcutsContainer {\n  /* position: absolute;\n  bottom: 0;\n  top: 0;\n  right: 0; */\n  display: flex;\n  /* align-items: center; */\n}\n\n@media (max-width: 900px) {\n  .paperContainer {\n    padding: 20px 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sideShortcuts {\n    display: block !important;\n  }\n\n  .css-ymyjcp-MuiGrid-root {\n    gap: 40px;\n  }\n\n  .homeContainer {\n    width: calc(100% - 225px);\n  }\n\n  .homeContainerGrid {\n    display: flex;\n    /* gap: 90px; */\n    justify-content: center;\n    padding: 0 30px;\n  }\n\n  .paperContainer {\n    text-align: center;\n    align-items: center;\n    /* width: 300px; */\n  }\n\n  .toggleButtonContainer {\n    display: none;\n  }\n}\n\n@media (max-width: 1200px) {\n  .sideShortcuts {\n    position: absolute;\n    right: -250px;\n    /* top: 30%;\n    bottom: 0; */\n    transition: right 0.3s ease;\n    z-index: 1;\n  }\n\n  .css-ymyjcp-MuiGrid-root {\n    flex-direction: column;\n  }\n\n  .homeContainer {\n    width: calc(100% - 50px);\n  }\n}\n\n@media (min-width: 1900px) {\n  .home .shortcuts ul li {\n    font-size: 24px;\n  }\n\n  .sideShortcuts {\n    top: 10%;\n  }\n}\n\n@media (min-width: 2200px) {\n  .home .started {\n    font-size: 40px !important;\n    margin-top: 4%;\n  }\n\n  .homeContainer {\n    width: calc(100% - 400px);\n  }\n\n  .sideShortcuts .MuiPaper-root {\n    width: 400px !important;\n    min-height: 100%;\n  }\n\n  .searchInput input {\n    width: 100% !important;\n    font-size: 25px !important;\n  }\n\n  .shortcuts ul li {\n    font-size: 27px !important;\n  }\n\n  .searchInput .css-i4bv87-MuiSvgIcon-root {\n    font-size: 50px !important;\n  }\n\n  .homeContainerGrid {\n    display: flex;\n    justify-content: center;\n    padding: 0 50px;\n  }\n\n  .paperContainer .mainButton Button {\n    height: 100px;\n    font-size: 250% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
